module.exports = __webpack_public_path__ + "fonts/TTNormsPro-LightItalic.3f3d345f.woff2";